<template>
  <div id="Help" class="Page Help">
    <Shape ref="shape" />
    <div class="Page_wrapper">
      <img src="/assets/images/cartes.svg" alt="Jeu de cartes" />
      <transition name="title" appear>
        <h2>Alors camarade, on bloque ?</h2>
      </transition>

      <transition name="content" appear>
        <p>Pensez à explorer la scène. Vous pouvez faire tourner la caméra à 360 degrès avec {{ $tools.isTouchDevice() ? 'votre doigt' : 'la souris' }}. N'hésitez pas à cliquer sur des éléments du décor pour trouver des indices.
        <br><br>Vous avez exploré la scène et trouvé les 3 indices ? Coco vous indique si vous avez trouvé le bon code. Rappelez-vous, le dernier matelot du navire, vous a confié le premier chiffre du code avant de sauter à l'eau, il s'agit du "un".
        Creusez-vous un peu les méninges et bonne année.<br><br>
        Amicalement,<br>
        <b>l'équipage LP5></b></p>
      </transition>
      
      <!-- <transition name="cta" appear>
        <button class="Cta" @click="close">Fermer</button>
      </transition> -->

      <div class="Close" @click="close"><img class="Shape_optim" src="/assets/images/shape-small.svg" /><i class="fad fa-times-circle"></i></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import page from "@/mixins/page"

import Shape from '@/components/partial/Shape'

export default {
  components: { Shape },
  mixins: [ page ],
  data () {
    return {
      
    }
  },
  methods: {
    close()
    {
      this.close = new Howl({
        src: ['/assets/sounds/close.mp3']
      });
      this.close.play()

      this.$el.querySelector('.Shape').classList.remove('Shape_content')
      this.$emit('closeHelp')
    }
  },
  created () {
  },
  mounted () {
    setTimeout( () => {
      this.$el.querySelector('.Shape').classList.add('Shape_content')
    }, 10)

    this.open = new Howl({
      src: ['/assets/sounds/open.mp3']
    });
    this.open.play()
  }
}
</script>

<style lang="stylus" scoped>

.Help

  position fixed
  top 0px
  left 0px
  height 100vh
  overflow-y hidden
  overflow-x visible
  z-index 10

  @media $medium

    overflow-y visible!important
    overflow-x visible!important

  @media $small

    overflow-y auto!important
    overflow-x hidden!important

  .Page_wrapper

    max-width 860px
    position relative
    width 70%
    text-align center

    @media $large

      width 100%
      max-width 1024px

    @media $small

      width 100%

  .longuevue

    position absolute
    left 72%
    bottom 20%
    width 100px

  .ancre

    position absolute 
    left 80%
    width 120px
    bottom 13%

</style>
